export default {
  confirmDelete: 'Are you sure you want to delete? This operation cannot be undone',
  confirmLogout: 'Are you sure you want to logout?',
  saveSuccess: 'Saved successfully',
  saveFailed: 'Save failed',
  deleteSuccess: 'Deleted successfully',
  deleteFailed: 'Delete failed',
  updateSuccess: 'Updated successfully',
  updateFailed: 'Update failed',
  networkError: 'Network error, please try again later',
  serverError: 'Server error, please try again later',
  timeout: 'Request timeout, please try again later',
  addSuccess: 'Added successfully',
  editSuccess: 'Edited successfully',
  actionSuccess: 'Operation successful',
  actionFailed: 'Operation failed',
  fetchFailed: 'Failed to fetch data',
  pleaseSelectProduct: 'Please select a product',
};
